import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/img/Vector.png'


const _hoisted_1 = { class: "flex flex-col px-[10px] items-center justify-center" }
const _hoisted_2 = { class: "text-center container max-w-[1024px] flex font-bold text-2xl w-auto md:max-w-[600px] md:my-[50px] my-[20px]" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mx-[10px] md:h-[35px] h-[25px]",
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "w-full md:flex relative md:min-h-[400px] h-auto" }
const _hoisted_5 = { class: "md:w-7/12 flex flex-col w-full md:mr-[20px]" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "list-disc ml-[30px]" }
const _hoisted_12 = { class: "list-disc ml-[30px]" }
const _hoisted_13 = { class: "list-disc ml-[30px]" }
const _hoisted_14 = { class: "list-disc ml-[30px]" }
const _hoisted_15 = { class: "list-disc ml-[30px]" }
const _hoisted_16 = { class: "list-disc ml-[30px]" }
const _hoisted_17 = { class: "list-disc ml-[30px]" }
const _hoisted_18 = {
  href: "../assets/Document/Document.pdf",
  download: "Document.pdf",
  class: "py-[5px] flex justify-center relative left-0 items-center text-center my-[20px] w-[100px] px-[10px] border-cyan-600 border rounded-[10px]"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.5 15.5H3.25C2.78587 15.5 2.34075 15.3156 2.01256 14.9874C1.68437 14.6592 1.5 14.2141 1.5 13.75V3.25C1.5 2.78587 1.68437 2.34075 2.01256 2.01256C2.34075 1.68437 2.78587 1.5 3.25 1.5H10.25M13.75 1.5V16.375M13.75 16.375L11.125 13.75M13.75 16.375L16.375 13.75",
    stroke: "#0FA958",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_20 = { class: "md:w-5/12 w-full relative md:ml-[20px]" }
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-start items-center" }, null, -1)
const _hoisted_23 = { class: "w-screen md:mt-[20px] mt-[10px] bg-gray-100 flex justify-center items-center" }
const _hoisted_24 = { class: "container max-w-[1024px] justify-center md:flex md:justify-between items-start" }
const _hoisted_25 = { class: "md:w-[calc(100%/3)] w-full p-[15px] py-[25px]" }
const _hoisted_26 = { class: "font-bold" }
const _hoisted_27 = { class: "mt-[15px]" }
const _hoisted_28 = { class: "list-disc ml-[30px] my-[10px]" }
const _hoisted_29 = { class: "list-disc ml-[30px] my-[10px]" }
const _hoisted_30 = { class: "list-disc ml-[30px] my-[10px]" }
const _hoisted_31 = { class: "list-disc ml-[30px] my-[10px]" }
const _hoisted_32 = { class: "md:w-[calc(100%/3)] w-full p-[15px] py-[25px]" }
const _hoisted_33 = { class: "font-bold" }
const _hoisted_34 = { class: "mt-[15px]" }
const _hoisted_35 = { class: "list-disc ml-[30px] my-[10px]" }
const _hoisted_36 = { class: "font-bold mr-[10px]" }
const _hoisted_37 = { class: "list-disc ml-[30px] my-[10px]" }
const _hoisted_38 = { class: "font-bold mr-[10px]" }
const _hoisted_39 = { class: "list-disc ml-[30px] my-[10px]" }
const _hoisted_40 = { class: "font-bold mr-[10px]" }
const _hoisted_41 = { class: "list-disc ml-[30px] my-[10px]" }
const _hoisted_42 = { class: "font-bold mr-[10px]" }
const _hoisted_43 = { class: "md:w-[calc(100%/3)] w-full p-[15px] py-[25px]" }
const _hoisted_44 = { class: "font-bold" }
const _hoisted_45 = { class: "mt-[15px]" }
const _hoisted_46 = { class: "list-disc ml-[30px] my-[10px]" }
const _hoisted_47 = { class: "list-disc ml-[30px] my-[10px]" }
const _hoisted_48 = { class: "list-disc ml-[30px] my-[10px]" }
const _hoisted_49 = { class: "list-disc ml-[30px] my-[10px]" }


export default /*#__PURE__*/_defineComponent({
  __name: 'One_trainings',
  props: {
    trainings: {}
  },
  setup(__props: any) {

    const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.trainings, (training) => {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.$t(training.nam)), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('ta')), 1),
            _createTextVNode(": " + _toDisplayString(_ctx.$t(training.target)), 1)
          ]),
          _hoisted_7,
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('pree')), 1),
            _createTextVNode(": " + _toDisplayString(_ctx.$t(training.pre)), 1)
          ]),
          _hoisted_9,
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("eo")), 1),
            _createTextVNode(": ")
          ]),
          _createElementVNode("ul", {
            class: _normalizeClass(training.style)
          }, [
            _createElementVNode("li", _hoisted_11, _toDisplayString(_ctx.$t(training.edu[0])), 1),
            _createElementVNode("li", _hoisted_12, _toDisplayString(_ctx.$t(training.edu[1])), 1),
            _createElementVNode("li", _hoisted_13, _toDisplayString(_ctx.$t(training.edu[2])), 1),
            _createElementVNode("li", _hoisted_14, _toDisplayString(_ctx.$t(training.edu[3])), 1),
            _createElementVNode("li", _hoisted_15, _toDisplayString(_ctx.$t(training.edu[4])), 1),
            _createElementVNode("li", _hoisted_16, _toDisplayString(_ctx.$t(training.edu[5])), 1),
            _createElementVNode("li", _hoisted_17, _toDisplayString(_ctx.$t(training.edu[6])), 1)
          ], 2),
          _createElementVNode("a", _hoisted_18, [
            _hoisted_19,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('booklet')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("img", {
            src: training.image,
            alt: "Image training",
            class: "min-w-[100%] h-auto mt-[10px] md:mt-[0px] md:max-h-[100%]"
          }, null, 8, _hoisted_21)
        ])
      ]),
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('pe')), 1),
            _createTextVNode(": "),
            _createElementVNode("ul", _hoisted_27, [
              _createElementVNode("li", _hoisted_28, _toDisplayString(_ctx.$t(training.PA[0])), 1),
              _createElementVNode("li", _hoisted_29, _toDisplayString(_ctx.$t(training.PA[1])), 1),
              _createElementVNode("li", _hoisted_30, _toDisplayString(_ctx.$t(training.PA[2])), 1),
              _createElementVNode("li", _hoisted_31, _toDisplayString(_ctx.$t(training.PA[3])), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('dod')), 1),
            _createTextVNode(": "),
            _createElementVNode("ul", _hoisted_34, [
              _createElementVNode("li", _hoisted_35, [
                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('du')) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t(training.Duration[0])), 1)
              ]),
              _createElementVNode("li", _hoisted_37, [
                _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('mo')) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t(training.Duration[1])), 1)
              ]),
              _createElementVNode("li", _hoisted_39, [
                _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('tgs')) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t(training.Duration[2] )), 1)
              ]),
              _createElementVNode("li", _hoisted_41, [
                _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('mod')) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t(training.Duration[3])), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t('per')), 1),
            _createTextVNode(": "),
            _createElementVNode("ul", _hoisted_45, [
              _createElementVNode("li", _hoisted_46, _toDisplayString(_ctx.$t(training.PR[0])), 1),
              _createElementVNode("li", _hoisted_47, _toDisplayString(_ctx.$t(training.PR[1])), 1),
              _createElementVNode("li", _hoisted_48, _toDisplayString(_ctx.$t(training.PR[2])), 1),
              _createElementVNode("li", _hoisted_49, _toDisplayString(_ctx.$t(training.PR[3])), 1),
              _createElementVNode("li", {
                class: _normalizeClass(["list-disc ml-[30px] my-[10px]", training.PREstyle])
              }, _toDisplayString(_ctx.$t(training.PR[4])), 3)
            ])
          ])
        ])
      ])
    ]))
  }), 256))
}
}

})